export default {
  // Common
  'common.tips.deliveryHome':
    'Het is mogelijk om dit product thuis te laten bezorgen.',
  'common.tips.pickUpStore':
    'Het is mogelijk om dit product af te halen in een winkel.',
  'common.tips.attention':
    'Opgelet: Helaas kunnen we een terugname van make-up producten niet aanvaarden omwille van hygiënische redenen.',

  'common.store.noLocationAuth':
    'Je hebt het delen van je huidige locatie geweigerd. Schakel deze toestemming in je browserinstellingen in',
  'common.store.searchHeading':'Zoek een G&W GezondheidsWinkel in de buurt',
  'common.store.searchSubHeading':'Wil je weten of er een Gezond & Wel winkel bij jou in de buurt is? Vul dan hieronder je postcode of woonplaats in.',
  'common.store.searchStore':'Zoek winkel',
  'common.store.storesAvailable':'Gevonden winkels',
  'common.store.addToFavourites': 'Opslaan als favoriet',

  'common.text.terms': 'Terms',
  'common.text.newMsg':
    'Ik wil graag op de hoogte gehouden worden van de laatste nieuws',
  'common.text.agreement':
    'Ik ga akkoord met de <a href="{link}" target="_blank" class="text-gw-grey-900 underline hover:no-underline">algemene voorwaarden*</a>',
  'common.text.login': 'Inloggen',
  'common.text.register': 'Registreren',
  'common.text.language': 'Taal',

  'common.text.newsletter': 'Meld je aan en ontvang 10% korting!',
  'common.text.newsletterSubscription':
    'Schrijf je nu in voor de G&W nieuwsbrief en ontvang direct 10% korting op je eerst volgende bestelling. Daarnaast blijf je altijd op de hoogte van onze actuele aanbiedingen!',
  'common.text.of': 'van',
  'common.text.results': 'resultaten',
  'common.text.advice': 'Advies nodig?',
  'common.text.mail': 'Mail ons',
  'common.text.chat': 'Chat met ons',
  'common.text.question': 'Vragen?',
  'common.text.contact': 'Bel ons',
  'common.text.securePayment': 'BETAALMETHODEN',
  'common.text.searchPlaceholder': 'Waar ben je naar op zoek?',
  'common.text.loginRegister': '',
  'common.text.welcome': 'Welkom',
  'common.text.logout': 'Uitloggen',
  'common.text.product': 'product',
  'common.text.products': 'producten',
  'common.text.continueShopping': 'Verder winkelen',
  'common.text.inclVAT': 'Incl. BTW',
  'common.text.previous': 'Vorige',
  'common.text.next': 'Volgende',
  'common.text.nextStep': 'Volgende stap',
  'common.text.promoCode': 'Kortingscode',
  'common.text.filterChosen': 'Je gekozen filters:',
  'common.text.price': 'Prijs',
  'common.text.sortOn': 'Sorteer op:',
  'common.text.moreInfoShort': 'meer info',
  'common.text.moreInfo': 'Meer informatie',
  'common.text.about': 'Over',
  'common.text.loading': 'Bezig met laden...',
  'common.text.id': 'id',
  'common.text.color': 'kleur',
  'common.text.toOrder': 'Bestellen',
  'common.text.viewMore': 'Bekijk meer',
  'common.text.viewAll': 'Bekijk alle gegevens',
  'common.text.changeData': 'Wijzig gegevens',
  'common.text.unknown': 'Onbekend',
  'common.text.loadMore': 'Laad meer',
  'common.text.click': 'Klik',
  'common.text.here': 'hier',
  'common.text.clickHere': 'klik hier',
  'common.text.share': 'Deel op {name}',
  'common.text.allow': 'toestaan',
  'common.text.refuse': 'weigeren',
  'common.text.filter': 'filtre',

  'title.news': 'Nieuws',
  'title.themes': "Thema's",
  'title.highlight': 'Uitgelicht',

  'text.viewAllPosts': 'Bekijk alle berichten',
  'text.noProduct': 'Geen product',
  'text.free': 'Gratis',
  'text.deliveryUnknown': 'Wordt in volgende stap berekend',
  'text.date': 'Datum',
  'text.amount': 'Bedrag',
  'text.voucher.activeVouchers': 'Mijn actieve vouchers',
  'text.voucher.productVouchers': 'Mijn beschikbare productvouchers',
  'text.voucher.paymentVouchers': 'Mijn beschikbare betaalvouchers',
  'text.voucher.add': 'Adressen',
  'text.sort.WeightingFactor:desc': 'Relevantie',
  'text.sort.GrossPrice:asc': 'Prijs: Laag naar hoog',
  'text.sort.GrossPrice:desc': 'Prijs: Hoog naar laag',
  'text.sort.Title:asc': 'Alfabetisch: A tot Z',
  'text.sort.Title:desc': 'Alfabetisch: Z tot A',
  'text.sort.CreationDate:desc': 'Nieuwste',
  'text.readMore': 'Lees verder',
  'text.redirect': 'Omleiden...',
  'text.mailto.subject': 'Bekijk deze pagina die super tof is',
  'text.mailto.body': 'Bekijk nu dit onwijs toffe {name}',
  'text.register.loyaltyCustomer':
    "Ja, ik wil sparen voor kortingen en extra's met Gezondheidswinkel",
  'text.cookie.introduction':
    'Deze website maakt gebruik van cookies, voor alle informatie omtrent ons cookiebeleid',
  'text.cookie.policy': 'cookie beleid',
  'text.allCategories': 'Alle categorieën',
  'text.remove.from.favorites': 'Wilt u dit product uit uw favorieten verwijderen?',
  'text.no': 'Nee',
  'text.remove.favorite.yes': 'Ja, verwijder product',

  'description.amount': 'bedrag dat op de kaart nog staat',

  // placeholder
  'placeholder.selectOne': 'Selecteer er een alstublieft',

  // button
  'button.createAccount': 'Account aanmaken',
  'button.register': 'Inschrijven',
  'common.button.checkout': 'Naar afrekenen',
  'common.button.pay': 'Betalen',
  'common.button.toCart': 'Winkelwagen',
  'common.button.cart': 'Winkelmand',
  'common.button.favorites': 'Favorieten',
  'common.button.location': 'Vestigingen',
  'common.button.account': 'Account',
  'common.button.removeFilter': 'Alle filters verwijderen',
  'common.button.viewAllOrder': 'Bekijk alle bestellingen',
  'common.button.addAddress': 'Adres toevoegen',
  'common.button.addToCartLong': 'Actie toevoegen aan winkelwagen',
  'common.button.addFavToCart': 'Toevoegen',

  // Login
  'login.title': 'Inloggen',
  'login.existing': 'Bestaande klanten',
  'login.forgotPassword': 'Je wachtwoord vergeten?',
  'login.oldPassword': 'Oud wachtwoord',
  'login.newPassword': 'Nieuw wachtwoord',
  'login.confirmPassword': 'Herhaal nieuw wachtwoord',
  'login.confirmPasswordNotice':
    'Het wachtwoord moet minimaal 8 karakters en minimaal 1 cijfer bevatten',
  'register.newAccount': 'Nieuw bij Gezond & Wel?',
  'register.newAccountSub': 'Registreer eenvoudig een account.',
  'title.order.guest': 'Bestellen zonder account',
  'subTitle.order.guest': 'Ga verder met bestellen zonder te registreren.',
  'button.order.noAccount': 'Bestellen als gast',
  'login.subExisting': 'Log in om makkelijk en snel bestellen.',
  'login.notLoggedin': 'Log in om jouw favorite winkel op te slaan.',

  // user information
  'userInfo.email': 'E-mailadres',
  'userInfo.password': 'Wachtwoord',
  'userInfo.confirmPassword': 'Wachtwoord bevestigen',
  'userInfo.gender': 'Aanhef',
  'userInfo.gender.Male': 'Man',
  'userInfo.gender.Female': 'Vrouw',
  'userInfo.gender.Neutral': 'Gender Neutraal',
  'userInfo.gender.title.Male': 'Dhr.',
  'userInfo.gender.title.Female': 'Mevr.',
  'userInfo.gender.title.Neutral': 'Gender Neutraal',
  'userInfo.firstName': 'Naam',
  'userInfo.middleName': 'Tussenvoegsel',
  'userInfo.lastName': 'Achternaam',
  'userInfo.phoneNumber': 'Telefoonnummer',
  'userInfo.mobile': 'Mobiel nummer',
  'userInfo.address.land': 'Land',
  'userInfo.address.SelectCountry': 'Selecteer land',
  'userInfo.address.postalCode': 'Postcode',
  'userInfo.address.houseNumber': 'Huisnummer',
  'userInfo.address.houseNumberExtension': 'Toevoeging',
  'userInfo.address.street': 'Straat',
  'userInfo.address.city': 'Woonplaats',
  'userInfo.address.dateOfBirth': 'Geboortedatum',

  // Checkout
  'checkout.overview.remarkPlaceholder':
    'Heb je vragen of opmerking? Laat het ons hier weten.',
  'checkout.shoppingBag': 'Je winkelwagen',
  'checkout.shoppingBagSubhead': 'Je hebt <strong>{count} artikelen</strong> in je winkelwagen',
  'checkout.postageCosts': 'Verzendkosten',
  'checkout.delivery': 'Bezorgadres',
  'checkout.deliverySub': 'Waar mogen we je pakje naartoe brengen?',
  'checkout.personalInformation': 'Persoonlijke gegevens',
  'checkout.tips.requireFields':
    'De velden met een * hebben wij nodig om je bestelling goed te kunnen verwerken.',
  'checkout.noAddressFindWarning':
    'Geen adres gevonden op basis van {postalCode} / {houseNumber}',
  'checkout.overview.shoppingBag': 'Overzicht winkelwagen',
  'checkout.overview.checkoutOrder': 'Bestelling afrekenen',
  'checkout.overview.billingAddress': 'FACTUUR ADRES',
  'checkout.overview.pickupAddress': 'Afhaaladres',
  'checkout.overview.deliveryAddress': 'Verzendadres',
  'checkout.overview.changeDeliveryMethod': 'Wijzig leveringsmethode',
  'checkout.paymentMethod': 'Betaalmethode',
  'checkout.paymentMethodSub': 'Laat je ons weten hoe je het liefst wilt betalen?',
  'checkout.success.breadcrumb': 'Bedankt - Order {orderNumber}',
  'checkout.success.title': 'Bedankt voor je bestelling.',



  'checkout.success.successtext': '<p>Dank voor je bestelling, wij zullen je order verwerken en z.s.m. naar je verzenden. Wanneer wij je bestelling gereed hebben voor verzending krijg je hier een bericht over.</p><br/>' +
  '<p>Voor vragen, opmerkingen en overige zaken kun je altijd contact opnemen met de G&W Webshop via onderstaande gegevens.</p>',
  'checkout.success.address':'<p>GezondheidsWinkel.nl</p>' +
    '<p>Curieweg 1</p>' +
    '<p>8013 RA Zwolle</p>' +
    '<p>Telefoon: 038-4276639</p>' +
    '<p>Email: secretariaat@genw.nl</p>'/*  +
    '<p>nummer: 05057072 0000</p>' +
    '<p>BTW nummer 80.43.79.415</p>' */,
  'checkout.success.packageDealWith':
    'Wij gaan meteen aan de slag met je pakketje.',
  'checkout.success.orderConfirm':
    'Binnen enkele uren ontvang je van ons de orderbevestiging op: <strong>{email}</strong> met <strong>ordernummer {orderNumber}</strong>.',
  'checkout.success.orderReceive':
    'Zodra je bestelling klaar staat in onze winkel te <a href="{link}" class="hover:underline"><strong>{store}</strong></a> ontvang je een bericht per e-mail.',
  'checkout.success.orderInAccount':
    'p.s. Je kunt je bestelling vanaf nu ook terug vinden in je account onder <a href="{link}" class="hover:underline"><strong>mijn bestellingen</strong></a>.',
  'checkout.success.collection':
    '<strong>BELANGRIJKE INFO voor de ophaling </strong>van je pakket:',
  'checkout.success.orderHandOver':
    'Van zodra je de mail met afhaalbevestiging van ons ontvangen hebt. Neem je ordernummer alvast bij de hand, zo kunnen we jouw bestelling sneller overhandigen.',
  'checkout.success.antwerpHover': 'Gezond & Wel',
  'checkout.success.time':
    ' Van maandag tem zaterdag: {time} - in de winkel aan de kassa.',
  'checkout.success.wine': 'Gezond & Wel',
  'checkout.success.orderQuestion':
    '<p>Vragen over je bestelling?</p><p>Meer info in "<a href="{link}" class="hover:underline"><strong>Verzenden & Bezorgen</strong></a>."</p><p><span>Of contacteer Gezondheidswinkel Online<a href="tel:0384276639" class="hover:underline">(<strong>038-4276639</strong>)</a>,</span><span>of mail naar<a href="mailto:webshop@gezondheidswinkel.nl" class="hover:underline"><strong>webshop@gezondheidswinkel.nl</strong></a>, van maandag t.e.m. vrijdag van 9u tot 18u.</span></p><p><strong class="underline"> TIP </strong>: Neem alvast je ordernummer klaar (≠ factuurnummer), zo kunnen wij je sneller verder helpen.</p>',
  'checkout.success.sign':
    '<p>Bedankt voor je bestelling!</p><p>En een fijne dag!</p><p>Gezond & Wel</p>',
  'checkout.success.enthusiastic': 'Enthousiast over je bestelling?',
  'checkout.success.social': 'Like ons op social media',
  'checkout.success.socialFacebook': 'Facebook',
  'checkout.success.socialInstagram': 'Instagram',
  'checkout.success.socialPinterest': 'Pinterest',
  'checkout.step.facts': 'Gegevens',
  'checkout.step.overview': 'Overzicht',
  'checkout.step.pay': 'Betalen',
  'checkout.step.confirmation': 'Bevestiging',
  'checkout.warning.autoFix':
    'Als u op "{button}" klikt, worden ze ook automatisch verwijderd.',

  // delivery
  'delivery.personal': 'persoonlijke account',
  'delivery.address.manager': '* Adressen zijn te beheren in je',
  'delivery.address.notPossible':
    'Thuisbezorging is niet mogelijk in alle landen.',

  // pickup
  'pickup.personal': 'persoonlijke account',
  'pickup.store.manager': 'Winkels zijn te beheren in je',

  // Cart
  'cart.Total': 'Totaal {quantity} product(en)',
  'cart.viewShoppingBag': 'Bekijk hele winkelwagen',
  'cart.changeShoppingBag': 'Bekijk mijn winkelwagen',
  'cart.discount': 'Actiekorting',
  'cart.totalPrice': 'Totaal producten',
  'cart.shippingCost': 'Bezorging',
  'cart.delivery.options': 'Leveringsmogelijkheden',
  'cart.delivery.options.PickupLocation': 'Ophalen bij een pickuppoint',
  'cart.delivery.options.PickupMyStore': 'Ophalen bij Mijn G&W vestiging',
  'cart.delivery.options.PickupStores': 'Ophalen bij een G&W winkel',
  'cart.delivery.options.PickupOtherStore':
    'Ophalen bij een andere G&W winkel',
  'cart.delivery.options.GuestPickupOtherStore':
    'Ophalen bij een G&W winkel',
  'cart.delivery.options.DeliveryMyAddress': 'Thuisbezorging',
  'cart.delivery.options.DeliveryAlternativeAddress':
    'Thuisbezorging (alternatief adres)',
  'cart.delivery.options.Pickup':
    'Ophalen bij een G&W winkel',
  'cart.delivery.options.CustomerAddress': 'Thuisbezorging',
  'cart.delivery.options.AlternativeAddress':
    'Thuisbezorging (alternatief adres)',
  'cart.delivery.guest.options.PickupLocation': 'Ophalen bij een pickuppoint',
  'cart.delivery.guest.options.Pickup':
    'Ophalen bij een G&W winkel',
  'cart.delivery.guest.options.CustomerAddress': 'Thuisbezorging',
  'cart.delivery.guest.options.AlternativeAddress':
    'Thuisbezorging',
  'cart.delivery.options.GuestDeliveryAlternativeAddress':
    'Thuisbezorging',
  'cart.noProducts': 'Er staan geen producten in je winkelwagen.',
  'cart.addToCartMobile': 'Toegevoegd!',
  'cart.addToCartDesktop': 'Toegevoegd aan je winkelwagen',
  'cart.inShoppingBag': 'Voeg toe aan winkelwagen',

  'cart.warning.overStock':
    'Sommige producten zijn momenteel niet op voorraad. Verlaag de hoeveelheid of verwijder deze producten.',
  'cart.warning.autoFix': 'om ze automatisch te verwijderen.',

  // Search Panel
  'searchPanel.brand': 'Merken',
  'searchPanel.suggestions': 'Suggesties',
  'searchPanel.categories': 'Categorieën',
  'searchPanel.searchResult': 'ZOEKRESULTATEN',
  'searchPanel.searchResultHeading': 'Je zocht op "{searchTerm}"',

  // Brand
  'brand.title': 'Merken',
  'brand.noResult': 'Nog geen merk',

  // error
  'error.message.notFound': '{name} is niet gevonden.',
  'error.message.product': 'Dit product',
  'error.message.oops': 'Oeps!',
  'error.message.lost': '',
  'error.message.notFoundPage':
    'We kunnen de pagina die je zoekt niet vinden.',
  'error.message.findWayBack': 'LAAT ONS JE HELPEN DE WEG TERUG TE VINDEN.',
  'error.message.backHome': 'Ga naar de homepagina',
  'message.register.fail': 'Registreren niet gelukt. Heb je al een account bij ons? Probeer dan een <a href="{link}" class="text-gw-grey-900 underline hover:no-underline">nieuw wachtwoord aan te vragen</a>.',

  // Product
  'product.connections.Size': 'Andere inhoud',
  'product.connections.Interesting': 'Andere bekeken ook',

  'product.label.limitedlabel': 'limited',
  'product.label.cleanbeautylabel': 'clean beauty',
  'product.label.nieuwlabel': 'new',
  'product.label.bestsellerlabel': 'best seller',
  'product.label.alcoholhoudend': 'NIX18',
  'product.label.allfilters': 'Toon alle filters',

  'product.text.unit': 'X',
  'product.text.ingredients': 'Ingrediënten',
  'product.text.composition': 'Samenstelling',
  'product.text.allergies': 'Allergenenverklaring',
  'product.text.dosage': 'Dosering',
  'product.text.description': 'Productinformatie',
  'product.text.specifications': 'Specificaties',
  'product.text.reviews': 'Reviews',
  'product.text.usage': 'Gebruiksaanwijzing',
  'product.text.introduction': 'Product omschrijving',
  'product.text.relatedProducts': 'Gerelateerde producten',
  'product.text.checkStoreStock': 'Bekijk de voorraad van alle stores',
  'product.text.recentlyViewed': 'Recent bekeken',
  'product.text.perPage': 'Producten per pagina',
  'product.text.summaryTitle': 'Deze wordt het',

  'product.availability.NotOrderable':
    'Dit product is niet voorradig maar kunnen we voor je bestellen, de levertijd bedraagt 2 tot 4 weken.',
  'product.availability.InStock':
    'Bestel tot 15u en je order wordt dezelfde dag verstuurd.',
  'product.availability.OutOfStock':
    'Dit product is niet voorradig maar kunnen we voor je bestellen, de levertijd bedraagt 2 tot 4 weken.',

  'product.OutOfStock':
    'Dit product is momenteel niet op voorraad. Verlaag het aantal of verwijder dit product',

  'product.specification.stock': 'Voorraad (WAAR?)',
  'product.specification.brand': 'Merk',
  'product.specification.group': 'Groep',
  'product.specification.categories': 'Categorieën',
  'product.specification.scanCode': 'Barcode',

  'product.facet.BrandTitle': 'Merk',
  'product.facet.WebNodeIds': 'Categorie',
  'product.facet.DiscountStatus': 'In de aanbieding',
  'product.facet.ExternalLine': 'Collectie',
  'product.facet.GrossPrice': 'Prijs',
  'product.facet.ExternalFragFamily': 'Geurfamilie',
  'product.facet.ExternalContent': 'Inhoud',
  'product.facet.ExternalProductSkinType': 'Huidtype',
  'product.facet.ExternalConcern': 'Huidzorg',
  'product.facet.ExternalFormulations': 'Textuur',
  'product.facet.ExternalCoverage': 'Dekking',
  'product.facet.ExternalFinish': 'Afwerking',
  'product.facet.ExternalSunProtection': 'Zonnebescherming',
  'product.facet.ExternalBenefits': 'Mascara Effect',
  'product.facet.ExternalHairConcern': 'Haarbehoefte',

  // Reviews
  'reviews.review': 'review',
  'reviews.reviews': 'reviews',
  'reviews.noReview': 'Nog geen reviews geschreven',
  'reviews.writeFirstReview': 'Schrijf de eerste review',
  'reviews.writeAReview': 'Schrijf een review',
  'reviews.about': 'Reviews',
  'reviews.title': 'REVIEW SCHRIJVEN',
  'reviews.rating': 'Beoordeling',
  'reviews.ratings': 'Beoordelingen',
  'reviews.experience': 'Je ervaring',
  'reviews.required': 'required',
  'reviews.button.send': 'Review verzenden',
  'reviews.averageRating': 'Gemiddelde beoordeling',
  'reviews.latest': 'Nieuwste reviews',
  'reviews.viewAll': 'Bekijk alle reviews',
  'reviews.rating.star': 'ster',
  'reviews.rating.stars': 'sterren',
  'reviews.rating.5': 'Uitstekend',
  'reviews.rating.4': 'Goed',
  'reviews.rating.3': '',
  'reviews.rating.2': '',
  'reviews.rating.1': '',
  'reviews.sorting.newestFirst': 'Nieuwste eerst',
  'reviews.sorting.oldestFirst': 'Oudste eerst',
  'reviews.sorting.mostStars': 'Meeste sterren',
  'reviews.sorting.fewestStars': 'Minste sterren',

  // Store
  'store.stores': 'winkels',
  'store.branches': 'Vestigingen',
  'store.closingTime': 'Vandaag open tot {closingTime}',
  'store.inStock': 'op voorraad',
  'store.lastStock': 'Laatste',
  'store.noStock': 'Niet',
  'store.text.open': 'Nu open',
  'store.text.at': 'Na',
  'store.text.close': 'Gesloten',
  'store.text.extraOpeningDays': 'Extra openingsdagen',
  'store.week.sunday': 'zondag',
  'store.week.monday': 'maandag',
  'store.week.tuesday': 'dinsdag',
  'store.week.wednesday': 'woensdag',
  'store.week.thursday': 'donderdag',
  'store.week.friday': 'vrijdag',
  'store.week.saturday': 'zaterdag',
  'page.store.title.contact': 'Contactgegevens',
  'page.store.title.openHours': 'Openingstijden',
  'link.gotoGoogleStore': 'plan een route',

  'footer.usp.sample':
    '<h3 class="font-bold"><svg aria-hidden="true" width="10" height="10" viewBox="0 0 32 32" focusable="false" class="mt-1 w-1 h-3 mr-6 mb-3 text-gw-primary fa-icon"><g><path d="M 44.122 56.936 c -4.081 0 -7.401 -3.32 -7.401 -7.401 v -9.068 c 0 -4.081 3.32 -7.401 7.401 -7.401 s 7.401 3.32 7.401 7.401 v 9.068 C 51.523 53.615 48.203 56.936 44.122 56.936 z M 44.122 35.064 c -2.979 0 -5.401 2.423 -5.401 5.401 v 9.068 c 0 2.979 2.423 5.401 5.401 5.401 s 5.401 -2.423 5.401 -5.401 v -9.068 C 49.523 37.487 47.101 35.064 44.122 35.064 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 64.232 56.936 c -4.081 0 -7.401 -3.32 -7.401 -7.401 v -9.068 c 0 -4.081 3.32 -7.401 7.401 -7.401 s 7.401 3.32 7.401 7.401 v 9.068 C 71.634 53.615 68.313 56.936 64.232 56.936 z M 64.232 35.064 c -2.979 0 -5.401 2.423 -5.401 5.401 v 9.068 c 0 2.979 2.423 5.401 5.401 5.401 s 5.401 -2.423 5.401 -5.401 v -9.068 C 69.634 37.487 67.211 35.064 64.232 35.064 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 32.169 56.936 H 19.367 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 12.803 c 0.552 0 1 0.447 1 1 S 32.722 56.936 32.169 56.936 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 25.768 56.936 c -0.552 0 -1 -0.447 -1 -1 V 36.031 l -4.812 3.509 c -0.447 0.325 -1.072 0.227 -1.397 -0.219 c -0.325 -0.446 -0.228 -1.072 0.219 -1.397 l 6.401 -4.667 c 0.305 -0.222 0.708 -0.254 1.042 -0.083 c 0.335 0.171 0.547 0.515 0.547 0.892 v 21.871 C 26.768 56.488 26.32 56.936 25.768 56.936 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 2 C 21.29 2 2 21.29 2 45 c 0 23.71 19.29 43 43 43 c 23.71 0 43 -19.29 43 -43 C 88 21.29 68.71 2 45 2 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path></g></svg>Punten sparen</h3><p class="mt-2 font-bold text-sm">Spaar bij elke aankoop in de webshop voor extra kortingen of andere geweldige deals!</p>',
  'footer.usp.free':
    '<h3 class="font-bold"><svg aria-hidden="true" width="10" height="10" viewBox="0 0 32 32" focusable="false" class="mt-1 w-1 h-3 mr-6 mb-3 text-gw-primary fa-icon"><g><path d="M 41.046 86.144 c -3.486 0 -6.322 -2.837 -6.322 -6.322 S 37.56 73.5 41.046 73.5 c 3.487 0 6.323 2.837 6.323 6.322 S 44.532 86.144 41.046 86.144 z M 41.046 76.467 c -1.85 0 -3.355 1.505 -3.355 3.355 s 1.505 3.355 3.355 3.355 c 1.851 0 3.356 -1.505 3.356 -3.355 S 42.896 76.467 41.046 76.467 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path><path d="M 80.581 33.518 C 77.501 16.67 62.724 3.856 45 3.856 c -17.724 0 -32.501 12.814 -35.581 29.662 C 4.103 34.283 0 38.855 0 44.379 v 11.321 c 0 5.038 3.413 9.285 8.045 10.575 c 0.048 0.092 0.105 0.182 0.174 0.265 c 7.408 8.931 16.898 13.801 28.252 14.542 v -2.971 c -9.529 -0.678 -17.627 -4.505 -24.15 -11.424 h 1.018 c 2.926 0 5.307 -2.381 5.307 -5.307 V 38.699 c 0 -2.926 -2.381 -5.306 -5.307 -5.306 h -0.877 C 15.548 18.252 28.961 6.823 45 6.823 c 16.039 0 29.452 11.43 32.539 26.57 h -0.878 c -2.925 0 -5.306 2.38 -5.306 5.306 v 22.681 c 0 2.926 2.381 5.307 5.306 5.307 h 2.352 C 85.071 66.688 90 61.759 90 55.701 V 44.379 C 90 38.855 85.897 34.283 80.581 33.518 z M 13.339 36.36 c 1.29 0 2.34 1.049 2.34 2.339 v 22.681 c 0 1.29 -1.049 2.34 -2.34 2.34 h -2.352 c -4.422 0 -8.02 -3.598 -8.02 -8.02 V 44.379 c 0 -4.422 3.598 -8.019 8.02 -8.019 H 13.339 z M 87.033 55.701 c 0 4.422 -3.598 8.02 -8.02 8.02 h -2.352 c -1.289 0 -2.339 -1.05 -2.339 -2.34 V 38.699 c 0 -1.29 1.05 -2.339 2.339 -2.339 h 2.352 c 4.423 0 8.02 3.597 8.02 8.019 V 55.701 z" style="stroke: currentColor; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 0.97;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path></g></svg>Stel je vraag</h3><p class="mt-2 font-bold text-sm">Heb je vragen, opmerking of een klacht? Laat het dan onze klantenservice weten. Samen zoeken wij naar een oplossing.</p>',
  'footer.usp.beautyAdvice':
    '<h3 class="font-bold"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" class="-mt-2 w-1 h-3 mr-6 mb-3 text-gw-primary fa-icon" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 16.016c1.245.529 2 1.223 2 1.984 0 1.657-3.582 3-8 3s-8-1.343-8-3c0-.76.755-1.456 2-1.984"></path><path stroke-width="2" stroke="currentColor" fill-rule="evenodd" d="M11.262 17.675 12 17l-.738.675zm1.476 0 .005-.005.012-.014.045-.05.166-.186a38.19 38.19 0 0 0 2.348-2.957c.642-.9 1.3-1.92 1.801-2.933.49-.99.885-2.079.885-3.086C18 4.871 15.382 2 12 2S6 4.87 6 8.444c0 1.007.395 2.096.885 3.086.501 1.013 1.16 2.033 1.8 2.933a38.153 38.153 0 0 0 2.515 3.143l.045.05.012.014.005.005a1 1 0 0 0 1.476 0zM12 17l.738.674L12 17zm0-11a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" clip-rule="evenodd"></path></svg>Vestigingen</h3><p class="mt-2 font-bold text-sm">Onze service staat voorop! Onze experts zijn opgeleid om jou het juiste advies te geven. Wanneer kom je eens langs?</p>',
  'footer.usp.club':
    '<h3 class="text-lg font-light uppercase">Fabulous Gezondheidswinkel Club</h3><p>Spaar punten voor meer<br />Beauty voordelen.</p>',

  // Breadcrumbs
  'breadcrumbs.writeReview': 'Schrijf beoordeling',
  'breadcrumbs.infrared': 'Infrared {name}',
  'breadcrumb.account.personal': 'Persoonlijke gegevens wijzigen',
  'breadcrumb.account.selectOtherStore': 'Mijn winkel wijzigen',
  'breadcrumb.account.changeAddress': 'Adresgegevens wijzigen',

  // Account
  'account.menu.accountOverview': 'Account overzicht',
  'account.menu.myAccount': 'Mijn account',
  'account.menu.myDetails': 'Persoonlijke gegevens',
  'account.menu.orderStatus': 'Laatst besteld',
  'account.menu.myPurchases': 'Mijn Facturen',
  'account.menu.myWishlist': 'Mijn verlanglijst',
  'account.menu.myLoyaltyPoints': 'Punten',
  'account.menu.myGiftCards': 'Cadeaubonnen',

  'account.title.accountOverview': 'Accountoverzicht',
  'account.title.myDetails': 'Mijn gegevens',
  'account.title.orderStatus': 'Mijn bestellingen',
  'account.title.myInvoices':  'Mijn Facturen',
  'account.title.myWishlist': 'Jouw favoriete producten',
  'title.myLoyaltyPoints': 'Mijn spaarpunten',
  'title.myPaymentVouchers': 'Mijn betaal-vouchers',
  'title.myProductVouchers': 'Mijn product-vouchers',
  'account.title.newsletter': 'Nieuwsbrief instellingen',
  'account.title.selectOtherStore': 'Kies een andere winkel',
  'account.title.invoiceAddress': 'Factuur adres',
  'account.title.deliveryAddress': 'Wijzig adressen',

  'account.myProfile': 'mijn profiel',
  'account.myProfile.lastOrder': 'Laatst besteld',
  'account.title.myDetail': 'Persoonlijke gegevens',
  'account.title.personalInfo': 'Persoonlijke gegevens',
  'account.title.address': 'Adresgegevens',

  'account.tips.hasProducts': 'Er zitten {count} producten in je winkelwagen.',
  'account.tips.noProducts': 'Er zitten geen producten in je winkelwagen.',
  'account.tips.points': 'Je hebt {points} punten gespaard bij Gezondheidswinkel.',
  'account.tips.noOrder': 'U heeft nog geen bestelling bij ons gedaan.',
  'account.tips.noSelectedStore': 'Je hebt geen winkel geselecteerd.',
  'account.tips.receiveNewsletter': 'Je ontvangt de nieuwsbrief.',
  'account.tips.pointsText': 'Bekijk hier wat je met je gespaarde punten kan doen!',

  'account.myDetail.personal': 'Persoonlijke gegevens',
  'account.myDetail.credentials': 'Inloggegevens',
  'account.myDetail.email': 'E-mail',
  'account.myDetail.deliveryAddress': 'Standaard bezorgadres',
  'account.myDetail.deliveryAddress.residentialOrBusinessAddress':
    'Woon- of Vestigingsadres',
  'account.myDetail.deliveryAddress.otherAddresses': 'Overige adressen',
  'account.myDetail.deliveryAddress.edit': 'Pas adres aan',
  'account.myDetail.billingAddress': 'Standaard factuuradres',
  'account.myDetail.myShop': 'Mijn winkel',
  'account.myDetail.newsletter': 'Nieuwsbrief instellingen',
  'account.change.personal': 'Wijzig persoonlijke gegevens',
  'account.change.password': 'Wijzig inloggegevens',
  'account.change.deliveryAddress': 'Bezorgadressen beheren',
  'account.change.billingAddress': 'Factuuradres wijzigen',
  'account.change.myShop': 'Mijn winkel wijzigen',
  'account.change.emailSetting': 'Wijzig e-mail instellingen',
  'account.myLoyaltyPoints.description': 'Beschrijving',
  'account.myLoyaltyPoints.value': 'Waarde',
  'account.myLoyaltyPoints.loyaltyNumber': 'Aantal spaarpunten:',
  'account.myLoyaltyPoints.loyaltyValue': 'Waarde spaarpunten:',

  'account.wishlist.emptyWishlist':
    'Er staan geen producten in je verlanglijst.',
  'account.wishlist.products': 'Er staan ook nog {number} producten in je favorieten.',
  'account.wishlist.clearWishlist': 'Alle producten verwijderen',
  'account.wishlist.addWishlistToCart': 'Alle producten in winkelwagen',
  'account.wishlist.noStock': 'Max aantal bereikt vanwege beperkte voorraad',
  'account.wishlist.wishListSubhead': 'Je hebt <strong>{count} artikelen</strong> op je lijstje staan',

  'account.newsletter.label': 'Nieuwsbrief',
  'account.newsletter.notAccept': 'Nee, ik wil geen nieuwsbrief ontvangen',
  'account.newsletter.isOptIn':
    'Ja, ik wil via de e-mail op de hoogte blijven van de laatste nieuwtjes',

  'account.purchase.details': 'Details',
  'account.purchase.reOrder': 'Opnieuw bestellen',
  'account.purchase.deliveryAddress': 'Verzendadres:',
  'account.purchase.pickupStore': 'Ophalen bij:',
  'account.purchase.billingAddress': 'FACTUUR ADRES:',
  'account.purchase.total': 'Totaal',
  'account.purchase.status': 'Status:',
  'text.orderNumber': 'Ordernummer:',
  'account.purchase.delivery': 'Levering:',
  'account.purchase.paymentMethod': 'Betaalmethode:',
  'account.invoices.invoiceNumber': 'Factuurnummer:',
  'account.transaction.buyFrom': 'Gekocht bij',
  'account.transaction.noTransactions':
    'Je hebt nog niets gekocht in één van onze winkels.',

  'account.save': 'Opslaan',
  'account.backToOverview': 'Terug naar overzicht',

  'account.changePasswordSuccess': 'Wachtwoord succesvol gewijzigd!',
  'account.changePasswordFailed': 'Veranderen van wachtwoord mislukt!',
  'account.saveSuccessfully': 'Succesvol opgeslagen',
  'account.saveFailed': 'Opslaan mislukt',
  'text.noAvailableVouchers': 'Er zijn geen vouchers beschikbaar',

  // resetPassword
  'title.forgotPassword': 'Wachtwoord vergeten?',
  'title.forgotPassword.success': 'JE WACHTWOORD VERGETEN',
  'text.nav.forgotPassword': 'Nieuw wachtwoord opvragen',
  'description.forgotPassword':
    'Vul hieronder je e-mailadres in en je ontvangt binnen enkele minuten een link waarmee je een nieuw wachtwoord kunt instellen.',
  'button.forgotPassword': 'Reset wachtwoord',
  'message.forgotPassword.sendSuccess':
    'Er is een e-mail verstuurd naar {email} met hierin een link waarmee je een nieuw wachtwoord kunt instellen',

  // Widget leaders
  'widget.usp.heading': 'Waarom kiezen voor Gezond & Wel?',
  'message.no.order': 'U heeft nog geen facturen.',

  "alcohol": {
    "ageCheck": "Je moet 18 jaar of ouder zijn om deze pagina te bezoeken",
    "checkContent": "Wij verkopen geen alcoholhoudende dranken aan jongeren onder de 18 jaar. Onze medewerkers en bezorgers vragen bij aankoop van alcohol om legitimatie aan alle mensen onder de 25 jaar.",
    "checkedMessage": "Ja, ik ben 18 jaar of ouder"
  },
}
